module.exports = __webpack_public_path__ + "static/media/norway_1.854ba1c7.png";